export const ADMIN_AUTH_KEY = "online-sale-admin";
export const ADMIN_LANG_KEY = "online-sale-admin-language";
export const ADMIN_TOKEN_KEY = "online-sale-admin-token";
export const CALL_CENTER_TOKEN_KEY = "online-sale-call-center-token";

export const INVALID_CREDENTIALS = "401"